export default __webpack_public_path__ + "static/media/carosel9.673b0df2.jpg";